import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import theme from '../../theme.js';
import React, { Suspense, lazy } from 'react';
import Layout from '../pages/Layout/Layout.jsx';
import DailyReport from '../pages/DailyReport/DailyReport.jsx';

// Lazy load components
const Home = lazy(() => import('../pages/home/Home.jsx'));
const MyWork = lazy(() => import('../pages/myWork/MyWork.jsx'));
const Login = lazy(() => import('../Login.jsx'));
const ActivityNotification = lazy(() => import('../pages/home/ActivityNotification.jsx'));
const Project = lazy(() => import('../pages/leadProject/Project.jsx'));
const LeadDetails = lazy(() => import('../pages/leadProject/LeadDetails.jsx'));
const AcitivitySummary = lazy(() => import('../pages/acitivities/AcitivitySummary.jsx'));
const SoftwareDevelopment = lazy(() => import('../pages/SoftwareDevelopment.jsx'));
const HeatMapSummary = lazy(() => import('../pages/heatMap/HeatMapSummary.jsx'));
const ClientVisitSummary = lazy(() => import('../pages/clientVisit/ClientVisitSummary.jsx'));
const AMCFollowUpSummary = lazy(() => import('../pages/amcFollowUp/AMCFollowUpSummary.jsx'));
const LeadStagesSummaryCom = lazy(() => import('../pages/leadProject/LeadStagesSummaryCom.jsx'));
const SoftwareUpdateSetting = lazy(() =>
  import('../pages/softwareUpdate/Master/SoftwareUpdateSetting.jsx')
);
const SoftwareUpdateSummary = lazy(() =>
  import('../pages/softwareUpdate/Transaction/SoftwareUpdateSummary.jsx')
);
const Booking = lazy(() => import('../pages/expenses/booking/Booking.jsx'));
const BookingVerify = lazy(() => import('../pages/expenses/verified/BookingVerify.jsx'));
const BookingConfirmed = lazy(() => import('../pages/expenses/comfimed/BookingConfirmed.jsx'));

const ProjectRoutes = () => {
  const user = useSelector((state) => state.user);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Suspense fallback={<div></div>}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/myWork" element={<MyWork />} />
          <Route path="/project" element={<Project />} />
          {isMobile && (
            <Route path="/todayActivity" element={<ActivityNotification user={user} />} />
          )}
          <Route path="/lead-details" element={<LeadDetails />} />
          <Route path="/acitivitySummary" element={<AcitivitySummary />} />
          <Route path="/software-management" element={<SoftwareDevelopment />} />
          <Route path="/heatMap" element={<HeatMapSummary />} />
          <Route path="/client-visit" element={<ClientVisitSummary />} />
          <Route path="/AMC-Followup" element={<AMCFollowUpSummary />} />
          <Route path="/lead-Stage" element={<LeadStagesSummaryCom />} />
          <Route path="/softwareUpdate" element={<SoftwareUpdateSetting />} />
          <Route path="/softwareUpdateTrans" element={<SoftwareUpdateSummary />} />
          <Route path="/expenseBooking" element={<Booking />} />
          <Route path="/bookingVerify" element={<BookingVerify />} />
          <Route path="/bookingConfirmed" element={<BookingConfirmed />} />
           <Route path="/dailyReport" element={<DailyReport />} />
        </Route>
        <Route path="/" element={user?.userCd ? <Navigate to="/myWork" replace /> : <Login />} />
      </Routes>
    </Suspense>
  );
};

export default ProjectRoutes;
